import { render, staticRenderFns } from "./VideoMeetings.vue?vue&type=template&id=4b5e11f2"
import script from "./VideoMeetings.vue?vue&type=script&lang=js"
export * from "./VideoMeetings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports